// @ts-check
// Comandos da 2.0.0 no menu de comandos (spec-2.0.0 seção 5.3; contrato 09 de campanhas base): junta o que cada área
// diz que já está pronto e despacha a execução para o módulo da área. O registro dos comandos (quais aparecem e onde)
// é do passo 0, em client/src/lib/command-registry.js; aqui só a ponte, para nenhuma frente editar o registro.
import { MARKETING_CONSENT_COMMAND_IDS, describeRecordMarketingConsent, runMarketingConsentCommand } from '../privacy/marketing-consent-commands.js';
import { WHATSAPP_CAMPAIGN_COMMAND_IDS, runWhatsappCampaignCommand } from '../whatsapp-campaigns/whatsapp-campaign-commands.js';
import { FLOW_COMMAND_IDS, isFlowDrilldownView, runFlowCommand } from '../flows/flow-commands.js';
import { EMAIL_CAMPAIGN_OBJECT_NAMES } from '../email/email-campaign-routes.js';
// 3.0.0: atendimento (F3) e retenção (F5) entram pela mesma ponte (contrato 10 de atendimento, seção 25)
import { SERVICE_DESK_COMMAND_IDS, runServiceDeskCommand } from '../service-desk/service-desk-commands.js';
import { RETENTION_COMMAND_IDS, runRetentionCommand } from '../retention/retention-commands.js';
// e os bots na conversa aberta (F4): Iniciar bot e Assumir conversa
import { BOT_COMMAND_IDS, runBotCommand } from '../bots/bot-commands.js';
import { isTenantModuleEnabled } from '../../data/metadata-store.js';

/** Comandos novos que as áreas já entregaram (os outros não aparecem). @returns {ReadonlySet<string>} */
export function readyCampaignCommandIds() {
  return new Set([...MARKETING_CONSENT_COMMAND_IDS, ...WHATSAPP_CAMPAIGN_COMMAND_IDS, ...FLOW_COMMAND_IDS, ...SERVICE_DESK_COMMAND_IDS, ...RETENTION_COMMAND_IDS, ...BOT_COMMAND_IDS]);
}

/** Parte do contexto dos comandos que vem das áreas da 2.0.0 e da 3.0.0 (o módulo ligado decide os do atendimento). */
export function campaignCommandContext() {
  return { campaignCommandIds: readyCampaignCommandIds(), emailCampaignObjectNames: EMAIL_CAMPAIGN_OBJECT_NAMES, isModuleEnabled: isTenantModuleEnabled };
}

/**
 * Campos da ficha aberta para os comandos da LGPD (CommandRecord).
 * @param {import('../../lib/field-metadata.js').ObjectMetadata} objectMetadata @param {Record<string, any>} record
 */
export function campaignRecordCommandContext(objectMetadata, record) {
  return describeRecordMarketingConsent(objectMetadata, record);
}

export { isFlowDrilldownView };

/**
 * Executa um comando da 2.0.0 pela área dona. Devolve false quando nenhuma área reconhece o comando.
 * @param {import('../../lib/command-registry.js').CommandDescriptor} command
 * @param {import('../command-menu/command-actions.js').CommandRuntime} runtime
 */
export async function runCampaignCommand(command, runtime) {
  for (const run of [runMarketingConsentCommand, runWhatsappCampaignCommand, runFlowCommand, runServiceDeskCommand, runRetentionCommand, runBotCommand]) {
    if (await run(command, runtime)) return true;
  }
  return false;
}
